// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a494b4cd","498":"a8650364","572":"86f2c8a1","787":"9a8854f1","880":"4eb59b7d"}[chunkId] + ".chunk.js";
};